// extracted by mini-css-extract-plugin
export default {"menu-box":"menu_menu-box__4NuMd","menu":"menu_menu__-jKP+","loginBox":"menu_loginBox__naYA3","sandwich":"menu_sandwich__g1L1G","man-img":"menu_man-img__M1Vzz"};